import ViMessages from '../locales/vi_VN.json';

const viLang = {
  messages: {
    ...ViMessages
  },
  locale: 'vi-VN',
};
export default viLang;
